"use client";

import { useEffect, useState } from "react";
import type { ComponentProps, ComponentType } from "react";

type AppProgressBarProps = ComponentProps<
  typeof import("next-nprogress-bar").AppProgressBar
>;

export function ProgressBarWrapper() {
  const [ProgressBar, setProgressBar] =
    useState<ComponentType<AppProgressBarProps> | null>(null);

  useEffect(() => {
    let isMounted = true;

    void import("next-nprogress-bar").then((mod) => {
      if (isMounted) {
        setProgressBar(() => mod.AppProgressBar);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!ProgressBar) return null;

  return (
    <ProgressBar
      height="4px"
      color="#4ade80"
      options={{ showSpinner: false }}
      shallowRouting
    />
  );
}
